import axios from 'axios';

const POLLINATIONS_API_BASE = "https://gen.pollinations.ai";
const POLLINATIONS_API_KEY = "pk_o7Ee9trx3BECMQOq";

const apiClient = axios.create({
  baseURL: POLLINATIONS_API_BASE,
  headers: {
    'Authorization': `Bearer ${POLLINATIONS_API_KEY}`,
    'Content-Type': 'application/json'
  }
});

/**
 * Handle API errors and return consistent messages
 */
const handleError = (error) => {
  if (error.response) {
    if (error.response.status === 401) return "Unauthorized. Check API key.";
    if (error.response.status === 403) return "API key missing required permission.";
    return error.response.data?.message || "Pollinations API Error";
  }
  return "Network error or service unreachable.";
};

export const getPollinationsProfile = async () => {
  try {
    const { data } = await apiClient.get('/account/profile');
    return { data, error: null };
  } catch (error) {
    return { data: null, error: handleError(error) };
  }
};

export const getPollinationsBalance = async () => {
  try {
    const { data } = await apiClient.get('/account/balance');
    return { data, error: null };
  } catch (error) {
    return { data: null, error: handleError(error) };
  }
};

export const getPollinationsUsage = async (params = {}) => {
  try {
    const { data } = await apiClient.get('/account/usage', { params });
    return { data, error: null };
  } catch (error) {
    return { data: null, error: handleError(error) };
  }
};

export const getPollinationsDailyUsage = async (params = { days: 30 }) => {
  try {
    const { data } = await apiClient.get('/account/usage/daily', { params });
    return { data, error: null };
  } catch (error) {
    return { data: null, error: handleError(error) };
  }
};